export default __webpack_public_path__ + "static/media/chint.d62450d8.jpg";